// extracted by mini-css-extract-plugin
module.exports = {"why":"styles_why__LFYLT","show":"styles_show__1Aylr","items":"styles_items__EEd1H","item":"styles_item__2pKes"};